/* eslint-disable max-len */
import React, {useContext} from 'react';
import {useLocation} from 'react-router-dom';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {createLinkToLogin} from '../../../modules/auth-pages/constants';
import {USER_ROLES} from '../../../website-ui/constants/user';
import {useUser} from '../../../website-ui/hooks/use-user';
import {CURRENT_BASE_TRIM, MODAL_ADD_PHONE} from '../../constants';
import {ModalContext} from '../../contexts/ModalContext';
import {isGolosNarodaActive} from '../../helpers';
import {Tooltip} from '../Tooltip';

import styles from './index.module.css';

function AuthAlert({className, withToolTip = true, onTelupdateClick, withCloseIcon = false, onClose, inModal = false}) {
  const {role, isAuthenticated} = useUser();
  const location = useLocation();

  const {setOpenModal} = useContext(ModalContext);
  const hasPhoneNumber = role === USER_ROLES.EXTENDED;
  const classNames = clsx(styles.container, className, {
    [styles.login]: !isAuthenticated,
    [styles.phoneNumber]: isAuthenticated && !hasPhoneNumber
  });

  const linkToLogin = createLinkToLogin({
    redirectURL: location.pathname === '/'
      ? CURRENT_BASE_TRIM
      : `${CURRENT_BASE_TRIM}${location.pathname}`
  });

  const onPhoneclick = () => {
    if (onTelupdateClick) {
      onTelupdateClick();
      return null;
    }

    setOpenModal({
      isOpen: true,
      type: MODAL_ADD_PHONE
    });
  };

  if (!isGolosNarodaActive) {
    return null;
  }

  if (isAuthenticated && hasPhoneNumber) {
    return null;
  }
  if (!isAuthenticated) {
    return (
      <div className={classNames}>
        {withCloseIcon && (
          <button className={styles.closeIcon} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M15.751 5.28651L14.714 4.24902L10.0005 8.96432L5.28698 4.24904L4.24989 5.28653L8.96337 10.0018L4.24878 14.7182L5.28587 15.7557L10.0005 11.0393L14.7151 15.7557L15.7522 14.7182L11.0375 10.0018L15.751 5.28651ZM14.7137 4.3436L15.6562 5.28651L10.9427 10.0018L15.6573 14.7182L14.7148 15.6611L14.7151 15.6614L15.6579 14.7182L10.9433 10.0018L15.6568 5.28651L14.714 4.34334L14.7137 4.3436ZM10.0002 10.9452L9.99993 10.945L5.2856 15.6611L5.28587 15.6614L10.0002 10.9452ZM5.28698 4.34336L10.0002 9.05837L9.99993 9.05863L5.28671 4.34363L5.28698 4.34336Z" fill="#212121" />
            </svg>
          </button>
        )}
        <Typography variant="text-14" className={styles.text}>
          Чтобы участвовать в голосовании,{' '}<br className={styles.break} />
          <a href={linkToLogin} rel="nofollow" className={styles.link}>
            <Typography variant="text-14" component="span">
              войдите в профиль{' '}
            </Typography>
          </a>
          и подтвердите свой номер телефона.
        </Typography>
        {withToolTip && (
          <Tooltip leftAlignment={inModal} />
        )}
      </div>
    );
  }

  if (!hasPhoneNumber) {
    return (
      <div className={classNames}>
        {withCloseIcon && (
          <button className={styles.closeIcon} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M15.751 5.28651L14.714 4.24902L10.0005 8.96432L5.28698 4.24904L4.24989 5.28653L8.96337 10.0018L4.24878 14.7182L5.28587 15.7557L10.0005 11.0393L14.7151 15.7557L15.7522 14.7182L11.0375 10.0018L15.751 5.28651ZM14.7137 4.3436L15.6562 5.28651L10.9427 10.0018L15.6573 14.7182L14.7148 15.6611L14.7151 15.6614L15.6579 14.7182L10.9433 10.0018L15.6568 5.28651L14.714 4.34334L14.7137 4.3436ZM10.0002 10.9452L9.99993 10.945L5.2856 15.6611L5.28587 15.6614L10.0002 10.9452ZM5.28698 4.34336L10.0002 9.05837L9.99993 9.05863L5.28671 4.34363L5.28698 4.34336Z" fill="#212121" />
            </svg>
          </button>
        )}
        <Typography variant="text-14" className={styles.text}>
          <Typography variant="text-14" component="button" className={styles.link} onClick={onPhoneclick}>
            Подтвердите ваш номер телефона,
          </Typography>
          {' '}чтобы принимать участие в голосовании.
        </Typography>
        {withToolTip && (
          <Tooltip leftAlignment={inModal} />
        )}
      </div>
    );
  }
}

export {AuthAlert};
